module.exports = __webpack_public_path__ + "img/portrait.c3e7e5b9.jpg";